<template>
  <div>
    <!-- Text选择区 -->
    <div ref="textContainer" @mouseup="captureSelection">{{ text }}</div>

    <!-- Concept Label区 -->
    <div v-for="(color, concept) in concepts" :key="concept">
      <el-button :style="{ backgroundColor: color, color: 'white' }" @click="annotate(concept)">{{ concept }}</el-button>
    </div>

    <!-- 标注结果展示区 -->
    <div v-for="highlightGroup in highlightGroups" :key="highlightGroup.id">
      <div v-for="highlight in highlightGroup.highlights" :key="highlight.id" :style="{background: highlight.color, color: 'white', margin: '0 2px'}">{{ highlight.text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: '这是一段很长的Text，它在浏览器中可能会换行显示。当用户选择其中的Text，它在浏览器中可能会换行显示。当用户选择其中的某个片的Text，它在浏览器中可能会换行显示。当用户选择其中的某个片的Text，它在浏览器中可能会换行显示。当用户选择其中的某个片的Text，它在浏览器中可能会换行显示。当用户选择其中的某个片的Text，它在浏览器中可能会换行显示。当用户选择其中的某个片的Text，它在浏览器中可能会换行显示。当用户选择其中的某个片的某个片段并点击Concept Label时，我们将在其下方显示对应的高亮Text。',
      concepts: {
        'ConceptA': 'red',
        'ConceptB': 'blue',
      },
      highlightGroups: [],
      currentRects: [],
    };
  },
  methods: {
    captureSelection() {
      const selection = window.getSelection();

      if (selection.rangeCount > 0) {
        this.currentRects = Array.from(selection.getRangeAt(0).getClientRects());
      }
    },
    annotate(concept) {
      if (!this.currentRects.length) return;

      const color = this.concepts[concept];
      const selectedText = window.getSelection().toString();

      const chunks = selectedText.split('\n');
      const newHighlights = chunks.map((chunk, idx) => ({
        id: Date.now() + idx,
        text: chunk,
        color
      }));

      this.highlightGroups.push({
        id: Date.now(),
        highlights: newHighlights
      });

      this.currentRects = [];
    }
  }
};
</script>
